// import visibilityObserver from './_modules/_visibilityObserver';
import CallSlick from './_module/_callSlick';

$(function(){
   // iosか判別
   const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);

   // iosの場合とその他の場合でアプリのリンクを出し分ける
   $('.js-spLink').on('click', e => {
     let link = '';

     if (isIOS) {
       link = $(e.currentTarget).data('iosLink');
     } else {
       link = $(e.currentTarget).data('androidLink');
     }
     location.href = link;
   });

  // コンテンツがスクロール内に入ったら吹き出しを出す
  $('.js-animationTrigger').one('inview', e => {
    $(e.currentTarget).find('.js-animationTarget').addClass('is-active');
  });

  new CallSlick({breakpoint: 600});
});



// WEBPACK FOOTER //
// ./js/common.js